/* eslint-disable no-param-reassign */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { EMPTY_FILTER_QUERY } from "./consts";

import type { FilterQueryType } from "./types";

const name = "bulkTemplates";

type BulkTemplatesState = {
  byId: Record<string, API.BulkTemplate>;
  list: string[]; // all IDs in display order
  pageMap: Record<string, string[]>; // page number: array of IDs
  next: string | null;
  selected: API.BulkTemplate | null;
  total: number;
  filters: FilterQueryType;
};

const initialState: BulkTemplatesState = {
  byId: {},
  list: [],
  pageMap: {},
  selected: null,
  next: null,
  total: 0,
  filters: EMPTY_FILTER_QUERY,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    upsertPage: (
      state,
      action: PayloadAction<{
        pageNumber: number;
        results: API.BulkTemplate[];
        total: number;
      }>,
    ) => {
      const { results, total, pageNumber } = action.payload;

      results.forEach((bulkTemplate: API.BulkTemplate) => {
        state.byId[bulkTemplate.id] = bulkTemplate;
      });

      state.pageMap[pageNumber] = results.map(
        (bulkTemplate: API.BulkTemplate) => bulkTemplate.id,
      );
      state.total = total;
    },

    updateFilters: (
      state,
      action: PayloadAction<Partial<BulkTemplatesState["filters"]>>,
    ) => {
      const { payload } = action;
      state.filters = {
        ...state.filters,
        ...payload,
      };
    },

    resetState: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { actions } = slice;

export default {
  [name]: slice.reducer,
};
